import { Injectable } from '@angular/core';
import { RepositoryBase } from '@asm/features/sync/repositories/repository-base';
import { LocalDeliveryRoute } from '@asm/features/quick-order/models/offline-reference-data.model';

@Injectable({ providedIn: 'root' })
export class DeliveryRouteRepository extends RepositoryBase<LocalDeliveryRoute> {
  protected readonly KEY_PATH = 'delivery_routes';
}
